'use client'

import { cn } from '@/lib/utils'
import { ComponentProps, useEffect, useState } from 'react'

type CustomKbdProps = {
  ctrl?: boolean
  keys: string[]
} & ComponentProps<'kbd'>

type OS = 'mac' | 'windows' | 'linux' | null

export function CustomKbd({ ctrl, keys, ...props }: CustomKbdProps) {
  const [os, setOS] = useState<OS>(null)

  useEffect(() => {
    if (window.navigator.userAgent.includes('Mac')) {
      setOS('mac')
    } else if (window.navigator.userAgent.includes('Win')) {
      setOS('windows')
    } else if (window.navigator.userAgent.includes('Linux')) {
      setOS('linux')
    }
  }, [])

  const finalProps = {
    ...props,
    className: cn(
      props.className,
      'text-foreground bg-border rounded-sm px-1 py-0.5 font-sans text-xs',
    ),
  }

  if (!os) {
    // Return a blank placeholder with the same dimensions to prevent layout shift
    return (
      <kbd
        {...finalProps}
        className="hidden"
      >
        &nbsp;
      </kbd>
    )
  }

  if (os === 'mac') {
    return (
      <kbd {...finalProps}>
        {ctrl ? '⌘' : ''}
        {keys.join('+')}
      </kbd>
    )
  }

  if (os === 'windows' || os === 'linux') {
    return (
      <kbd {...finalProps}>
        {ctrl ? 'Ctrl' : ''}
        {keys.join('+')}
      </kbd>
    )
  }

  return null
}
